var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"color":_vm.type,"bottom":true,"multi-line":true},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.snackbarTexts)?_c('ul',_vm._l((_vm.snackbarTexts),function(message){return _c('li',{key:message},[_vm._v(_vm._s(message))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }